import classNames from 'classnames/bind';

import { useToggle } from '@mantine/hooks';

import Pipeline from 'types/pipeline';

import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { Drawer } from 'components/Drawer/DrawerDeprecated';
import { Heading } from 'components/Heading/Heading';
import { Icon } from 'components/Icon/IconDeprecated';
import { Text } from 'components/Text/Text';

import { PipelinePickerWithTemplates } from './PipelinePickerWithTemplates';
import styles from './PipelinePicker.module.scss';

const c = classNames.bind(styles);

export type PipelinePickerProps = {
  pipeline: Pipeline | null | undefined;
  hasPipelines: boolean;
  onPipelineSelect: (pipeline: Pipeline) => void;
  className?: string;
};

export function PipelinePicker({
  pipeline,
  hasPipelines,
  onPipelineSelect,
  className,
}: PipelinePickerProps) {
  const [isSelectingPipeline, toggleIsSelectingPipeline] = useToggle();

  function handlePipelineSelect(pipeline: Pipeline) {
    toggleIsSelectingPipeline(false);
    onPipelineSelect(pipeline);
  }

  return (
    <>
      <Box className={c('deployments-select-pipeline', className)} size="small">
        {pipeline ? (
          <Heading level="4" asChild>
            <strong>
              <Icon name="pipeline" />
              <span>{pipeline.name}</span>
            </strong>
          </Heading>
        ) : (
          <Text>No workflow selected</Text>
        )}
        <Button
          className={c('deployments-select-pipeline-btn')}
          variant={pipeline ? 'secondary' : 'primary'}
          size="small"
          onClick={() => toggleIsSelectingPipeline()}
        >
          Select workflow
        </Button>
      </Box>

      <Drawer
        title="Select workflow"
        open={isSelectingPipeline}
        onClose={toggleIsSelectingPipeline}
      >
        <PipelinePickerWithTemplates
          hasPipelines={hasPipelines}
          onPipelineSelect={handlePipelineSelect}
        />
      </Drawer>
    </>
  );
}
